import request from '../request'
import download from '../download'

// 查询付款申请列表
export function fetchPaymentList(params) {
    return request({
        url: '/finance-service/payment-application/list',
        params
    })
}

// 导出付款申请列表
export function exportPaymentList(data) {
    return download({
        url: '/finance-service/payment-application/export',
        method: 'post',
        data
    })
}

// 发起审批
export function submitApproval(data) {
    return request({
        url: '/finance-service/payment-application/startReview',
        method: 'post',
        data
    })
}

// 查询付款申请详情
export function fetchPaymentDetail(id) {
    return request({
        url: `/finance-service/payment-application/query/${id}`,
    })
}

// 查询付款申请详情（用于重新提交回显）
export function fetchPaymentApplicationDetail(id) {
    return request({
        url: `/finance-service/payment-application/${id}`,
    })
}

// 查询合同详情
export function fetchContractDetail(id) {
    return request({
        url: `/project-service/contract/query/${id}`,
    })
}

// 重新发起审批
export function resubmitReview(data) {
    return request({
        url: '/finance-service/payment-application/resubmitReview',
        method: 'post',
        data
    })
}
